import React, { Component } from 'react'
import styled from 'styled-components'
import Item from './Item'
import ItemImage from './ItemImage'
import { connect } from 'react-redux'
import { theme, media } from '../theme'
import { MobileTilesGroup } from './LevelChooser'
import Heading from './Heading'
import PlayButtonConnected from './PlayButton'

import CharacterKeoniShaka from '../assets/images/character--keoni-shaka@3x.png'

const Container = styled.div`
  align-items: center;
  display: ${(p) => (p.isOpen ? 'flex' : 'none')};
  height: 100%;
  justify-content: center;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
`
const Modal = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  left: 0;
  top: 0;
  width: 100%;
  z-index: 12;

  ${media.greaterThan('medium')`
    height: 100%;
    position: absolute;
  `};
`
const Content = styled.div`
  background: linear-gradient(0deg, ${theme.color.Tip.bg.join(',')});
  border-radius: ${theme.spacing(-1)};
  font-family: ${theme.fontFamily.primary};
  padding: ${theme.spacing(1)};
  position: relative;
  display: flex;
  margin: 0 50px;
  width: 85%;
  height: 100%;

  ${media.greaterThan('medium')`
    height: 380px;
    left: 50%;
    margin: 0;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 700px;
  `};
`
const Flex = styled.div`
  flex-direction: column;
  display: flex;
  margin-bottom: -25px;
  width: 100%;
  ${media.greaterThan('medium')`
  flex-direction: row;
  width: unset;
  margin-bottom: 0;  
`};
`
const Copy = styled.div`
  display: none;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: 62%;
  padding: 0 0 0 3rem;
  ${media.greaterThan('medium')`
    display: flex;  
  `};
`

const MobileCopy = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  justify-content: center;
  padding: 0 10px;
  width: 100%;

  ${media.greaterThan('medium')`
    display: none;
  `};
`

const TilesWrapper = styled.div`
  flex-shrink: 0;
  margin: 0 auto;

  width: 70%;

  ${media.greaterThan('medium')`
    padding-top: 0;
    width: 46%;
  `};
`

const Tiles = styled.div`
  position: relative;
  ${media.greaterThan('medium')`
  position: absolute;
`};
`

const TipBackground = styled.div`
  background-color: ${(p) => (p.block ? 'rgba(0, 0, 0, 0.6)' : 'transparent')};
  height: 100%;
  width: 100%;
  left: 0;
  pointer-events: ${(p) => (p.block ? 'auto' : 'none')};
  position: absolute;
  top: 0;
  z-index: 11;
`

const StyledItem = styled(Item)`
  display: none;
  ${media.greaterThan('large')`    
    display: block;
  `};
`

const RaffleConfirmationHeading = styled(Heading)`
  color: ${theme.color.limeGreen};
`

class RoomChooserModal extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    let { modalIsActive, selectedRoom, hasEnteredRaffle, clearedQuizRoomIds } =
      this.props
    selectedRoom = selectedRoom.split('-').join(' ')

    const showRaffleConfirmation =
      hasEnteredRaffle && clearedQuizRoomIds.length === 3

    return (
      <Container isOpen={modalIsActive}>
        <Modal>
          <Content>
            <Flex>
              <StyledItem width={23} left={-14} bottom={9}>
                <ItemImage src={CharacterKeoniShaka} />
              </StyledItem>

              <Copy>
                {showRaffleConfirmation && (
                  <RaffleConfirmationHeading level={3} large>
                    Thanks for entering!
                  </RaffleConfirmationHeading>
                )}

                <Heading textAlign={'left'} level={2} last={true}>
                  Select another room to find out more ways to save money
                </Heading>
              </Copy>

              <MobileCopy>
                {showRaffleConfirmation && (
                  <RaffleConfirmationHeading level={3} large>
                    Thanks for entering!
                  </RaffleConfirmationHeading>
                )}

                <Heading textAlign={'center'} level={2}>
                  Select another room to find out more ways to save money
                </Heading>
              </MobileCopy>

              <TilesWrapper>
                <Tiles>
                  <MobileTilesGroup
                    selectedRoom={selectedRoom}
                    context="modal"
                  />
                </Tiles>
              </TilesWrapper>
            </Flex>

            <PlayButtonConnected context="modal" />
          </Content>
        </Modal>

        <TipBackground block={true} />
      </Container>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    modalIsActive: state.gameProgress.modalIsActive,
    selectedRoom: state.gameProgress.selectedRoom,
    hasEnteredRaffle: state.quizzes.hasEnteredRaffle,
    clearedQuizRoomIds: state.quizzes.clearedQuizRoomIds,
  }
}

const RoomChooserModalConnected = connect(
  mapStateToProps,
  null,
)(RoomChooserModal)
export default RoomChooserModalConnected



// WEBPACK FOOTER //
// ./src/components/RoomChooserModal.js